var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { log } from '../../utils/logger';
import { AuthRepository } from '../repositories/auth.repository.impl';
export class AuthService {
    constructor() {
        this.repository = new AuthRepository();
    }
    refreshTokenAsync(oldRefreshToken) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.repository.refreshToken(oldRefreshToken);
                if (!response) {
                    log.warn(`Error llamando a refresh token con el oldRfreshToken: ${oldRefreshToken}`);
                    return {
                        accessToken: null,
                        expiration: null,
                        refreshToken: null,
                    };
                }
                const { accessToken, expiration, refreshToken } = response;
                return { accessToken, expiration, refreshToken };
            }
            catch (error) {
                log.error('Error en refreshTokenAsync:', error);
                return {
                    accessToken: null,
                    expiration: null,
                    refreshToken: null,
                };
            }
        });
    }
}
